export const styledSendCannedMessagesView = {'&:focus-visible': {outline: 'none'}}

export const styledHeader = {
    '& svg': {
        color: '$icon',
        width: '20px',
    },
    'display': 'flex',
    'flexWrap': 'wrap',
    'gap': '10px',
    'marginBottom': '0px',
    'padding': '10px 16px 0 16px',
}

export const styledTitle = {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
    marginRight: 'auto',
    minWidth: 0,
}

export const styledHelpers = {
    alignItems: 'center',
    color: '$icon',
    display: 'flex',
    gap: '12px',
}

export const styledSmall = {
    '& i': {fontWeight: 'bold'},
    '& svg, & i': {marginRight: '6px'},
    'alignItems': 'center',
    'display': 'inline-flex',
}

export const styledActions = {
    alignItems: 'center',
    display: 'flex',
    gap: '4px',
}

export const styledList = {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '25vh',
    overflowY: 'auto',
    padding: '0.6rem',
}

export const styledButton = {
    '& svg': {
        color: '$buttonIcon',
        width: '20px',
    },
    '&:focus': {backgroundColor: '$cannedMessageBackgroundFocus'},
    '&:focus-visible': {outline: 'none'},
    '&:hover': {backgroundColor: '$cannedMessageBackgroundHover'},
    'background': 'transparent',
    'border': 0,
    'color': '$cannedMessageKeywordText',
    'display': 'flex',
    'gap': '6px',
    'padding': '0.4rem',
    'textAlign': 'left',
}

export const styledMessageContainer = {
    display: 'flex',
    flexDirection: 'column',
}

export const styledKeywords = {
    alignItems: 'center',
    color: '$cannedMessageKeywordText',
    display: 'flex',
    gap: '10px',
}

export const styledShared = {color: '$cannedMessageSharedText'}

export const styledMessage = {
    color: '$cannedMessageText',
    whiteSpace: 'pre-line',
}
